// -----------------------------------------------------------------------------
// Scripts for sales points
// -----------------------------------------------------------------------------

let infoWindows = [];
import { Tooltip } from 'bootstrap/dist/js/bootstrap';

const initMap = (mapEl) => {
  // Find marker elements within map.
  const markers = mapEl.querySelectorAll('.marker');
  const mapZoom = mapEl.getAttribute('data-zoom');

  // Create gerenic map.
  const mapArgs = {
    zoom: parseFloat(mapZoom),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: false,
    scrollwheel: false,
  };

  const googleMap = new google.maps.Map(mapEl, mapArgs);

  // Add markers.
  googleMap.markers = [];

  markers.forEach((element) => {
    initMarker(element, googleMap);
  });

  // Center map based on markers.
  centerMap( googleMap );

  // Return map instance.
  return googleMap;
}

const initMarker = (markerEl, map) => {
  // Get data from marker.
  const icon = markerEl.getAttribute('data-icon');
  const lat = markerEl.getAttribute('data-lat');
  const lng = markerEl.getAttribute('data-lng');
  const latLng = {
    lat: parseFloat(lat),
    lng: parseFloat(lng)
  };

  // Create marker instance.
  const marker = new google.maps.Marker({
    position: latLng,
    map: map,
    icon: `/wp-content/themes/oleomac/dist/images/marker-icon-${icon}.png`
  });

  // Append to reference for later use.
  map.markers.push(marker);

  // If marker contains HTML, add it to an infoWindow.
  if(markerEl.innerHTML) {

    // Create info window.
    const infowindow = new google.maps.InfoWindow({
      content: markerEl.innerHTML
    });

    infoWindows.push(infowindow);

    // Show info window when marker is clicked.
    google.maps.event.addListener(marker, 'click', function() {
      for (var i = 0; i < infoWindows.length; i++) {
        infoWindows[i].close();
      }

      infowindow.open(map, marker);
    });

    google.maps.event.addListener(map, 'click', function() {
      infowindow.close();
    });

    google.maps.event.addListener(infowindow, 'domready', function() {
      const exampleEl = document.querySelectorAll('.point-service');
      const tooltipList = [...exampleEl].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
    });
  }
}

const centerMap = (map) => {
  // Create map boundaries from all map markers.
  const bounds = new google.maps.LatLngBounds();

  map.markers.forEach(function(marker){
    bounds.extend({
      lat: marker.position.lat(),
      lng: marker.position.lng()
    });
  });

  // Case: Single marker.
  if(map.markers.length == 1) {
    map.setCenter(bounds.getCenter());

  // Case: Multiple markers.
  } else {
    map.fitBounds(bounds);
  }
}

if(document.querySelector('.sales-points')) {
  initMap(document.querySelector('#salesPointsMap'));
}